import type { PropsWithChildren, ReactElement } from 'react'
import { headerActions } from './Header.css'

export const HeaderActions = ({
  children
}: PropsWithChildren): ReactElement => {
  return <div className={headerActions}>{children}</div>
}
